module.exports = __webpack_public_path__ + "img/governates.532f350e.svg";